import Api from "~/service/Api";

class PasswordResetDisambiguationRepository {
  create(data) {
    return Api.post("/password-reset-disambiguation", data);
  }
}

export default PasswordResetDisambiguationRepository;
